import React from 'react';
import { formatRuntime, parseRuntime } from '../../data/runtimeutils';

import { triggerActionEvent } from './common';
import PSInput from './psinput';

export default class RuntimeInput extends React.PureComponent {

	constructor(props) {
		super(props);
		this.state = {text: ''};
		this.onBlur = this.onBlur.bind(this);
		this.processText = this.processText.bind(this);
	}

	processText() {
		const value = parseRuntime(this.state.text);
		if (value === null && this.state.text) {
			this.setState({text: ''});
		}
		if (typeof this.props.value === 'number' || typeof value === 'number') {
			this.props.onChange(value);
		}
	}

	inputFilter(value) {
		return value;
	}

	onBlur() {
		this.processText();
		if (this.props.onBlur) {
			this.props.onBlur();
		}
	}


	static getDerivedStateFromProps(nextProps, prevState) {
		if (prevState.value === nextProps.value) {
			return null;
		}
		return {
			text: formatRuntime(nextProps.value),
			value: nextProps.value
		};
	}

	render() {
		return (
			<PSInput
				data-name={this.props.name}
				data-autofocusid={this.props.autoFocusId}
				className={'ps-input runtime' + (this.props.readOnly ? ' readonly' : '')}
				placeholder={this.props.placeholder}
				value={this.state.text}
				onChange={e => {
					this.setState({text: this.inputFilter(e.target.value)});
				}}
				onKeyDown={(e) => {
					if (e.keyCode === 13) {
						this.processText();
						triggerActionEvent(e.target);
					}
					if (this.props.onKeyDown) {
						this.props.onKeyDown(e);
					}
				}}
				textAlign="right"
				spellCheck="false"
				autoComplete="off"
				name={this.props.name}
				onBlur={this.onBlur}
				size={this.props.size}
				readOnly={this.props.readOnly}
				tabIndex={this.props.readOnly ? '-1' : '0'}
			/>
		);
	}
}

